import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import UploadCalendar, { CalEvent } from '../components/UploadCalendar';

// 타 사이트 iframe 임베드용 행사 현황 위젯. 무인증·공개 데이터만 사용(세션 불필요).
// 라우트: /embed/:handle (핸들에 '@' 접두사 허용 → 제거). 서버가 /embed/* 에 대해
// X-Frame-Options 를 제거해 임의 오리진 프레이밍을 허용한다.
const EmbedCalendar: React.FC = () => {
  const { handle: raw } = useParams<{ handle: string }>();
  const handle = raw ? raw.replace(/^@/, '') : '';
  const [events, setEvents] = useState<CalEvent[]>([]);
  const [state, setState] = useState<'loading' | 'ok' | 'notfound'>('loading');

  useEffect(() => {
    if (!handle) { setState('notfound'); return; }
    let alive = true;
    fetch(`/public-upload/@${encodeURIComponent(handle)}/calendar`)
      .then((r) => r.json().then((j) => ({ ok: r.ok, j })))
      .then(({ ok, j }) => {
        if (!alive) return;
        if (ok && j?.success) { setEvents(j.data?.events ?? []); setState('ok'); }
        else setState('notfound');
      })
      .catch(() => alive && setState('notfound'));
    return () => { alive = false; };
  }, [handle]);

  if (state === 'loading') return <div className="p-4 text-center text-gray-400 text-sm">불러오는 중…</div>;
  if (state === 'notfound') return <div className="p-4 text-center text-gray-400 text-sm">존재하지 않는 페이지입니다.</div>;
  return (
    <div className="p-3 bg-white min-h-screen">
      <UploadCalendar events={events} handle={handle} />
    </div>
  );
};

export default EmbedCalendar;
